import { render, staticRenderFns } from "./ModattaSideModalNewBrand.vue?vue&type=template&id=7f76d152"
import script from "./ModattaSideModalNewBrand.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalNewBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports